module.exports = __webpack_public_path__ + "d6211eb9545165b2e42058ae4ea3321f.pdf";